import React, { useMemo } from 'react'
import Tab from '@/v2/components/common/Tab'
import PendingActionsIcon from '@mui/icons-material/PendingActions'
import { useUnconfirmedAppointments } from '@/v2/hooks/appointments/useUnconfirmedAppointments'
import {
  DEFAULT_RANGE,
  rangeDates,
} from '@/v2/containers/unconfirmed-appointments/utils'
import { nowOnClinicTimezone } from '@/v2/utils/convert'
import { Icon, Badge } from './styles'

// The count is the page's default view, the next 7 days, so both share one
// request.
const UnconfirmedTab = () => {
  const dates = useMemo(
    () => rangeDates(DEFAULT_RANGE, nowOnClinicTimezone()),
    []
  )
  const { appointments } = useUnconfirmedAppointments(dates)
  const count = appointments.length

  return (
    <Tab
      id="unconfirmed-button"
      title="Unconfirmed"
      href="/v2/unconfirmed-appointments"
      justify="center"
    >
      {count > 0 ? (
        <Badge badgeContent={count} color="secondary">
          <Icon>
            <PendingActionsIcon />
          </Icon>
        </Badge>
      ) : (
        <Icon>
          <PendingActionsIcon />
        </Icon>
      )}
    </Tab>
  )
}

export default UnconfirmedTab
